import React, { useState } from "react";
import { color, motion } from "framer-motion";
import { createClient } from "@supabase/supabase-js";
import {
  Stepper,
  Step,
  Typography,
  Button,
  Tooltip,
  Spinner
} from "@material-tailwind/react";
import Confetti from "react-confetti";
import bg from "../assets/images/rainbow.png";
import { useCopyToClipboard } from "usehooks-ts";
import {Link} from "react-router-dom";
import { ImageColorPicker } from 'react-image-color-picker';
import Compressor from "compressorjs";


const supabaseUrl = "https://mzovfnxteplyeeckgsyj.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im16b3Zmbnh0ZXBseWVlY2tnc3lqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTMwMzg2ODIsImV4cCI6MjAyODYxNDY4Mn0.khPxrT2ESnpGSMSryIXRrZn_K9ke6vT5nCldiM-i0wo";

const supabase = createClient(supabaseUrl, supabaseKey);

const Stepform = () => {
  const [imageFile, setImageFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    gender: "",
    phone: "",
    email: "",
    city: "",
    pincode: "",
    insta: "",
  });
  const [phoneError, setPhoneError] = useState("");
  const [PCError, setPCError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [step, setStep] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [isLastStep, setIsLastStep] = React.useState(false);
  const [isFirstStep, setIsFirstStep] = React.useState(false);
  const [value, copy] = useCopyToClipboard();
  const [copied, setCopied] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const handleColorPick = (color) => {
    console.log('Selected color:', color);
    // const hexColor = rgbToHex(color);
    setSelectedColor(color);
  };

  const handleNext = () => !isLastStep && setActiveStep((cur) => cur + 1);
  const handlePrev = () => !isFirstStep && setActiveStep((cur) => cur - 1);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  async function signInWithEmail() {
    const { data, error } = await supabase.auth.signInWithOtp({
      email: formData.email,
      options: {
        shouldCreateUser: true,
        emailRedirectTo: "https://juice-cosmetics.vercel.app",
      },
    });
  }

  const getDominantColor = (imageFile) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const pixelData = imageData.data;

        const colorMap = {};
        let maxCount = 0;
        let dominantColor = "";

        for (let i = 0; i < pixelData.length; i += 4) {
          const r = pixelData[i];
          const g = pixelData[i + 1];
          const b = pixelData[i + 2];
          const rgb = `${r},${g},${b}`;
          colorMap[rgb] = (colorMap[rgb] || 0) + 1;
          if (colorMap[rgb] > maxCount) {
            maxCount = colorMap[rgb];
            dominantColor = rgb;
          }
        }

        const hex = rgbToHex(dominantColor);
        resolve(hex);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = URL.createObjectURL(imageFile);
    });
  };

  const rgbToHex = (rgb) => {
    const [r, g, b] = rgb.split(",").map(Number);
    const hex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0");
    return `#${hex}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "email") {
      setEmailError(
        validateEmail(value) ? "" : "Invalid email address"
      );
    }

    if (name === "phone") {
      setPhoneError(
        validatePhone(value) ? "" : "Invalid phone number"
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowModal(true);
    setIsLoading(true);
  
    if (emailError || phoneError || PCError) {
      console.error("Validation errors. Please check your inputs.");
      setIsLoading(false);
      return;
    }
  
    try {
      new Compressor(imageFile, {
        quality: 0.5,
        success: async (compressedImage) => {
          try {
            const randomInt = Math.floor(10000000 + Math.random() * 90000000); 
  
            const newFilename = `public_${randomInt}_${imageFile.name}`;
  
            const { data: imageData, error: imageError } = await supabase.storage
              .from("image")
              .upload(newFilename, compressedImage);
  
            if (imageData) {
              const imageUrl = await supabase.storage
                .from("image")
                .getPublicUrl(newFilename);
  
              console.log("Image URL:", imageUrl);
  
              const { error: insertError } = await supabase.from("users").insert([
                {
                  name: formData.name,
                  age: formData.age,
                  gender: formData.gender,
                  phone: formData.phone,
                  email: formData.email,
                  city: formData.city,
                  pincode: formData.pincode,
                  insta: formData.insta,
                  image_url: imageUrl,
                  detected_color: selectedColor,
                },
              ]);
  
              await signInWithEmail();
  
              setIsLoading(false);
  
              if (insertError) {
                throw insertError;
              }
  
              console.log("Data uploaded successfully!");
            } else if (imageError) {
              throw imageError;
            }
          } catch (error) {
            console.error("Error uploading compressed image:", error);
            setIsLoading(false);
          }
        },
        error: (err) => {
          console.error("Image compression error:", err.message);
          setIsLoading(false);
        },
      });
    } catch (error) {
      console.error("Error compressing image:", error);
      setIsLoading(false);
    }
  };
  
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (phone) => {
    const re = /^[0-9]{10}$/;
    return re.test(phone);
  };

  const validatePincode = (pincode) => {
    const re = /^[0-9]{6}$/;
    return re.test(pincode);
  };
  

  const nextStep = () => {
    !isLastStep && setActiveStep((cur) => cur + 1);
    setStep(step + 1);
  };

  const prevStep = () => {
    !isFirstStep && setActiveStep((cur) => cur - 1);
    setStep(step - 1);
  };

  const redoStep = () => {
    setStep(1);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "email") {
      setEmailError(
        validateEmail(value) ? "" : "Invalid email address"
      );
    }

    if (name === "phone") {
      setPhoneError(
        validatePhone(value) ? "" : "Invalid phone number"
      );
    }
    if (name === "pincode") {
      setPCError(
        validatePincode(value) ? "" : "Invalid Pincode"
      );
    }
  };

    const [selectedColor, setSelectedColor] = useState('');

    const shareOnTwitter = () => {
      const url = "https://juice-cosmetics.vercel.app"; 
      const text = "🎉 I'm a step closer in turning my wildest color wish into reality! Participate in the ‘Wish a Color, We Deliver’ Contest and get a chance to win your own personalized nail polish color! 💄Challenge JUICE COSMETICS now! #WishAColorContest #JuiceCosmetics\n";
      const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
      window.open(twitterUrl, "_blank");
    };
  
    const shareOnFacebook = () => {
      const url = "https://juice-cosmetics.vercel.app"; 
      const text = "🌟🎨 Check out this amazing contest! I'm a step closer in turning my wildest color wish into reality! 💅✨ Participate in the ‘Wish a Color, We Deliver’ Contest and get a chance to win your own personalized nail polish color! 💄 Challenge JUICE COSMETICS now! #WishAColorContest #JuiceCosmetics"; // Your custom text
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`;
      window.open(facebookUrl, "_blank");
    };
  
    const shareOnInstagram = () => {
      const url = "https://juice-cosmetics.vercel.app"; 
      const text = "Check out this amazing contest! #WishAColorContest"; 
      // alert(`Share this link: ${url} and paste the text: ${text} in your Instagram post.`);
      const instaUrl = "https://www.instagram.com/p/C6LLOuxs5NG/?img_index=1";
      window.open(instaUrl, "_blank");
    };
  
    const shareOnWhatsApp = () => {
      const url = "https://juice-cosmetics.vercel.app"; 
      const text = "🌟🎨 I'm a step closer in turning my wildest color wish into reality!\n\n💅✨ Participate in the ‘Wish a Color, We Deliver’ Contest and get a chance to win your own personalized nail polish color!\n\n💄 Challenge JUICE COSMETICS now!\n#WishAColorContest #JuiceCosmetics\n\n🎁Participation Link:"; 
      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}%0A${encodeURIComponent(url)}`;
      window.open(whatsappUrl, "_blank");
    };


  return (
    <div className="flex  -mt-[70%] sm:-mt-52 bg-transparent">
      <div className="container relative flex flex-col w-4/5 mx-auto">
        <h1 className="mt-16 text-3xl font-montserratbold  text-center  md:text-4xl bg-gradient-to-tr from-[#7a0242]  via-[#fe508a]  to-[#52dc17] inline-block text-transparent bg-clip-text ">
          FILL THE FORM
          <p className="mx-auto mt-1 text-sm text-gray-600 font-montserrat-reg sm:text-lg">
            & Get a chance to be a winner!
          </p>
        </h1>


        <div className="w-3/4 mx-auto mt-5 sm:w-1/3">
          <Stepper
            activeStep={activeStep}
            lineClassName="bg-gray-400"
            activeLineClassName="bg-pink-300"
            isLastStep={(value) => setIsLastStep(value)}
            isFirstStep={(value) => setIsFirstStep(value)}

          >
            <Step               className=" !bg-pink-200 text-white/75 cursor-pointer font-montserrat-reg"
              activeClassName="ring-0 !bg-pink-500 text-white"
              completedClassName="!bg-pink-500 text-white " onClick={() => setStep(1)}>1</Step>
            <Step        className=" !bg-gray-400 text-white/75 cursor-pointer font-montserrat-reg"
              activeClassName="ring-0 !bg-pink-500 text-white"
              completedClassName="!bg-pink-500 text-white"  onClick={() => setStep(2)}>2</Step>
          </Stepper>
        </div>

        <form onSubmit={handleSubmit} className="mx-auto md:w-4/5 rounded-3xl ">
          {step === 1 && (
            // Step 1: Upload image
            <motion.div
              key={step}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="py-12 mx-auto md:w-3/5"
            >
              <div className="relative flex flex-col justify-center w-full h-full max-w-full overflow-hidden border-2 border-pink-300 rounded-2xl">
                <form onSubmit={handleSubmit} className="">
                  <div className="justify-center mx-auto p-5 w-[90%] h-[90%]">
                    <label
                      className="justify-center w-full transition rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none"
                      id="drop"
                    >
                      {imageFile ? (
              <div>
<div className="relative flex items-center justify-center w-full h-full py-4 my-auto">
  <div className="w-full h-full overflow-hidden relative">
    <ImageColorPicker
      onColorPick={handleColorPick}
      imgSrc={URL.createObjectURL(imageFile)}
      zoom={2}
      className="object-contain w-full h-full"
    /> 
    <div className="absolute top-0 right-0 z-[99999] mt-2 mr-2 w-10 h-10 rounded-md shadow-md" style={{ backgroundColor: selectedColor }}></div>
  </div>
</div>


<div className="w-full text-center">
  {selectedColor ? (
    <>
      <p className="mt-1 text-sm font-medium text-gray-700">Selected Color</p>
      <div className="flex items-center justify-center p-2 mx-auto">
        {/* <div className="w-6 h-6 rounded-full shadow-md" style={{ backgroundColor: selectedColor }}>
        </div> */}
        {selectedColor}
      </div>
    </>
  ) : (
    <p className="text-gray-500 text-sm text-center">Point at any element to extract color</p>
  )}
</div>

            </div>
            
                     
                     
                      ) : (
                        <>
                        <div className="items-center justify-center h-full">
  <div className="items-center px-20 pt-20">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 20 20"
      className="justify-center mx-auto"
    >
      <path
        fill="#888888"
        d="m5.122.282l-.348 1.071A2.2 2.2 0 0 1 3.376 2.75l-1.072.348l-.022.006a.423.423 0 0 0 0 .798l1.072.348a2.2 2.2 0 0 1 1.399 1.397l.348 1.07a.423.423 0 0 0 .798 0l.348-1.07a2.2 2.2 0 0 1 1.399-1.403l1.072-.348a.423.423 0 0 0 0-.798L7.646 2.75a2.2 2.2 0 0 1-1.377-1.397L5.92.283a.423.423 0 0 0-.799 0M.217 8.213l.766-.248a1.58 1.58 0 0 0 .998-.999l.25-.764a.302.302 0 0 1 .57 0l.248.764a1.58 1.58 0 0 0 .984.999l.765.248a.302.302 0 0 1 0 .57l-.765.249a1.58 1.58 0 0 0-1 1.002l-.248.764a.302.302 0 0 1-.57 0l-.249-.764a1.58 1.58 0 0 0-.999-.999l-.765-.248a.302.302 0 0 1 0-.57zM3 11.901v.599A2.5 2.5 0 0 0 5.5 15h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 12.5 3H9.912q.087.235.088.496q0 .266-.091.504h2.59a1.5 1.5 0 0 1 1.5 1.5v7c0 .232-.053.45-.146.647L10.2 9.495a1.7 1.7 0 0 0-2.404 0l-3.652 3.652A1.5 1.5 0 0 1 4 12.5v-2.19l-.015.037l-.26.802c-.1.25-.26.46-.48.62a1.3 1.3 0 0 1-.245.132m8.498-4.397a1.002 1.002 0 1 0 0-2.004a1.002 1.002 0 0 0 0 2.004m-2.003 2.698l3.652 3.652A1.5 1.5 0 0 1 12.5 14h-7c-.232 0-.45-.053-.647-.146l3.652-3.652a.7.7 0 0 1 .99 0"
      />
    </svg>
  </div>
  <br/>
  <div className="justify-center mx-auto text-sm font-medium text-center text-gray-600 pb-20">
    <span>Upload your</span><br/>
    <span>color reference image</span>
  </div>
</div>


                            
                        </>
                      )}
                      {!imageFile && (
                        <input
                          type="file"
                          onChange={handleFileChange}
                          className="hidden"
                          accept="image/*"
                          id="input"
                        />
                      )}
                    </label>
                  </div>

                  
                </form>
                
              </div>
                      
              
              <div className="flex justify-between w-full mt-16">
                <Button onClick={prevStep} disabled={isFirstStep}>
                  Prev
                </Button>
                <Button
  className="bg-pink-500"
  onClick={nextStep}
  disabled={!imageFile || isLoading}
>
  Next
</Button>

              </div>
            </motion.div>
          )}
          {step === 2 && (
            <motion.div
              key={step}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="mx-auto md:w-3/5"
            >
              {/* Step 2: Fill details */}
              {
                <div className="flex items-center justify-center p-2 pt-6">
                  <div className="px-6 bg-white sm:py-5 lg:px-8">
                    <form className="max-w-2xl mx-auto mt-10 sm:mt-15">
                      <div className="grid grid-cols-1 gap-x-5 gap-y-6 sm:grid-cols-2">
                        <div>
                          <label
                            htmlFor="name"
                            className="block text-sm font-semibold leading-6 text-gray-900"
                          >
                            Name <span className="text-red-500">*</span>
                          </label>
                          <div className="mt-2.5">
                            <input
                              required
                              type="text"
                              name="name"
                              id="name"
                              autoComplete="name"
                              className="block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6"
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        
                        <div>
                          <label
                            htmlFor="phone"
                            className="block text-sm font-semibold leading-6 text-gray-900"
                          >
                            Phone number <span className="text-red-500">*</span>
                          </label>
                          <div className="mt-2.5">
                            <input
                              required
                              type="tel"
                              name="phone"
                              id="phone"
                              autoComplete="tel"
                              className={`block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6 ${
                                phoneError ? "border-red-500" : ""
                              }`}
                              onChange={handleInputChange}
                            />
                            {phoneError && (
                              <p className="mt-1 text-xs text-red-500">
                                {phoneError}
                              </p>
                            )}
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="gender"
                            className="block text-sm font-semibold leading-6 text-gray-900"
                          >
                            Gender <span className="text-red-500">*</span>
                          </label>
                          <div className="mt-2.5">
                            <input
                              required
                              type="text"
                              name="gender"
                              id="gender"
                              className={`block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6 ${
                                phoneError ? "border-red-500" : ""
                              }`}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="age"
                            className="block text-sm font-semibold leading-6 text-gray-900"
                          >
                            Age <span className="text-red-500">*</span>
                          </label>
                          <div className="mt-2.5">
                            <input
                              required
                              type="number"
                              name="age"
                              id="age"
                              autoComplete="age"
                              className="block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6"
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        <div className="w-full sm:col-span-2 sm:w-1/2">
                          <label
                            htmlFor="email"
                            className="block text-sm font-semibold leading-6 text-gray-900"
                          >
                            Email <span className="text-red-500">*</span>
                          </label>
                          <div className="mt-2.5">
                            <input
                              required
                              type="email"
                              name="email"
                              id="email"
                              autoComplete="email"
                              className={`block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6 ${
                                emailError ? "border-red-500" : ""
                              }`}
                              onChange={handleInputChange}
                            />
                            {emailError && (
                              <p className="mt-1 text-xs text-red-500">
                                {emailError}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="grid w-full grid-cols-1 gap-x-8 gap-y-6">
                          <div>
                            <label
                              htmlFor="city"
                              className="block text-sm font-semibold leading-6 text-gray-900"
                            >
                              City <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-2.5">
                              <input
                                required
                                type="text"
                                name="city"
                                id="city"
                                autoComplete="city"
                                className="block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6"
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="state"
                              className="block text-sm font-semibold leading-6 text-gray-900"
                            >
                              Pincode <span className="text-red-500">*</span>
                            </label>
                            <div className="mt-2.5">
                              <input
                                required
                                type="number"
                                name="pincode"
                                id="pincode"
                                autoComplete="pincode"
                                className="block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6"
                                onChange={handleInputChange}
                              />{PCError && (
                              <p className="mt-1 text-xs text-red-500">
                                {PCError}
                              </p>
                            )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5">
                        <label
                          htmlFor="insta"
                          className="block text-sm font-semibold leading-6 text-gray-900"
                        >
                          Instagram ID
                        </label>
                        <div className="mt-2.5">
                          <input
                            type="text"
                            name="insta"
                            id="insta"
                            autoComplete="insta"
                            className="block text-sm font-montserrat-reg font-normal w-full rounded-md border-2 border-gray-400 px-3.5 py-2 text-gray-900  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-500 sm:text-sm sm:leading-6"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              }
              <div className="flex justify-between my-10">
                <Button onClick={prevStep} disabled={isFirstStep}>
                  Prev
                </Button>
                <Button
      type="button"
      onClick={handleSubmit}
      className="font-bold text-white bg-pink-500"
      disabled={!formData.name || !formData.age || !formData.phone || !formData.email || !formData.city || !formData.pincode || isLoading || emailError || phoneError || PCError }
    >
      {isLoading ? (
        <Spinner color="blue" size="sm" />
      ) : (
        "Submit"
      )}
    </Button>
              </div>
            </motion.div>
          )}
        </form>
      </div>
      {showModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
        <Confetti />
        <div className="flex items-center justify-center min-h-screen px-4 text-center">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <div class="relative overflow-hidden">
            <div class="inline-block align-bottom bg-white rounded-lg px-2  pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div class="text-center p-8 pb-8 z-10">
                <h1 class="text-3xl md:text-5xl font-bold bg-gradient-to-br from-[#7a0242] via-[#f32d9a] via-[#f7568b]  to-[#4dfc03] inline-block text-transparent bg-clip-text">
                  THANK YOU
                </h1>
                <p class="text-sm md:text-xl text-gray-600">
                  for your participation in our
                </p>
                <p class="text-xl md:text-xl font-bold text-[#8237B6] pt-4">
                  "Wish A Color, We Deliver" Contest!
                </p>
                <div class="fixed bottom-0 right-0 z-0">
                  <img src={bg} alt="" class="sm:w-48 sm:h-48 w-32 h-40" />
                </div>
              </div>
              <section class="flex flex-col md:flex-row">
              <div class="flex-1 mx-6 mb-6 mt-0">
                <p class="text-sm text-gray-600 text-center">
                Spread the word and increase your odds of winning!
                </p>
                  <hr class="my-2" />
                  <div class="flex flex-wrap justify-center">
                    <button onClick={shareOnWhatsApp} class="bg-[#49C958] mx-2 text-center my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                      
                      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"/></svg> 
                    </button>
                    <button onClick={shareOnFacebook} class="bg-[#1877F2] mx-2 text-center my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 2h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg> 
                    </button>
                    <button onClick={shareOnInstagram} class="bg-black mx-2 text-center instagram my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                      <svg className="w-5 h-5 " xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"/></svg>
                    </button>
                    <button onClick={shareOnTwitter} class="bg-black z-[99999] mx-2 text-center my-auto rounded-lg flex text-white text-xs text-center self-center px-3 py-2 ">
                    <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"/></svg>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default Stepform;